module.exports = __webpack_public_path__ + "d5e4283aafd8e30076bd95d9e75b74bc.svg";